<template>
  <div class="section">
    <div class="section_wrap row">
      <h6 class="--blue70 mb10">{{ $t('details') }}</h6>
      <div class="reh_details_container">
        <div class="reh_con_scroll">
          <KvTable v-if="detailsAndRecordComponentIdxProps === 1" :items="showFixedRehabilitationDetails"/>
          <KvTable v-if="detailsAndRecordComponentIdxProps === 1" :items="showRehabilitationDetails"/>
          <div v-if="detailsAndRecordComponentIdxProps === 0" class="mt60">
            {{ $t('rehabilitation.select_list_for_detail') }}
          </div>
        </div>
        <div
            v-if="patientInfoProps.check && detailsAndRecordComponentIdxProps === 1 && this.refinedExerciseListProps.length > 0"
            :class="refinedExerciseListProps[selectedRowsProps].exerciseStatus === 4 || refinedExerciseListProps[selectedRowsProps].exerciseStatus === 0 ? 'reh_btn' : 'hidden'"
        >
          <div
              v-if="this.refinedExerciseListProps.length > 0 && refinedExerciseListProps[selectedRowsProps].exerciseStatus === 4"
              class="bottom_btn_2 mt20">
            <a @click="updateExerciseStatus(2)" class="btn blue btn_basics pointer no-drag">{{
                $t('status.accomplished')
              }}</a>
            <a @click="updateExerciseStatus(1)" class="btn red btn_basics pointer no-drag">{{
                $t('status.terminated')
              }}</a>
          </div>
          <div
              v-if="this.refinedExerciseListProps.length > 0 && refinedExerciseListProps[selectedRowsProps].exerciseStatus === 0"
              class="bottom_btn_2 mt20">
            <a @click="$modal.show('add-edit-exercise-modal', {type : 'edit', data : refinedExerciseListProps[selectedRowsProps]})"
               class="btn deepGray btn_basics pointer no-drag">{{ $t('status.edit') }}</a>
            <a @click="$modal.show('yes-or-no-modal', {questionType:'delete', function: deleteExerciseGuide})"
               class="btn red btn_basics pointer no-drag">{{ $t('status.delete') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KvTable from '@/components/Table/kvTable';
import {
  showFixedRehabilitationDetails,
  showRehabilitationDetails
} from "@/components/modal/detailsAndRecord/details";

export default {
  props: [
    'refinedExerciseListProps',
    'selectedRowsProps',
    'detailsAndRecordComponentIdxProps',
    'patientInfoProps',
  ],
  components: {KvTable},
  data() {
    return {
      selectedExerciseProps: {}
    }
  },
  methods: {
    updateExerciseStatus(status) {
      this.$emit('updateExerciseStatus', status);
    },
    deleteExerciseGuide() {
      this.$emit('deleteExerciseGuide');
    },
    updateSelectedExerciseProps() {
      this.selectedExerciseProps = this.refinedExerciseListProps[this.selectedRowsProps]
    }
  },
  computed: {
    showFixedRehabilitationDetails() {
      this.updateSelectedExerciseProps();
      return showFixedRehabilitationDetails(this);
    },
    showRehabilitationDetails() {
      this.updateSelectedExerciseProps();
      return showRehabilitationDetails(this);
    }
  },
}
</script>
<style lang="scss">
.flex_child_2_2 {
  -webkit-box-flex: 2;
  -ms-flex: 2 2 2rem;
  flex: 2 2 2rem;

  .reh_con_scroll {
    .table-container {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .item-parent:nth-child(odd) {
      grid-column: 1 / 3;
    }

    .item-parent:nth-child(even) {
      grid-column: 3 / 5;
    }

    .item-parent:nth-child(12) {
      grid-column: 1 / 5;
    }

    .item-parent:nth-child(13) {
      grid-column: 1 / 5;
    }
  }
}

.reh_con_scroll {
  .table-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: max-content;
    width: 100%;
    text-align: left;

    .item-parent {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0.5rem;
      height: 45px;

      .item-title {
        flex: 2 1 1rem;
        font-weight: 700;
      }

      .item-value {
        flex: 3 3 1rem;
      }
    }
  }
}

.reh_btn {
  max-height: 120px;
}

.reh_details_container {
  display: flex;
  flex-direction: column;
  height: 340px;

  .reh_con_scroll {
    max-height: 230px;
    min-height: 220px;
  }
}
</style>